export default{
    methods:{
        selectCurrency(currency) {
            if(window.bus){
                window.bus.$emit('currency.changed', currency);
            }
            this.$store.dispatch('setCurrencyState', currency).catch(error => {
                this.$store.dispatch('createError', error);
            });
        }
    }
}